<template>
  <modal class="modalCG" @before-open="iphoneModalsSet" @before-close="close" :name="name" height="auto" :adaptive="true" :scrollable="true">
      <div class="modal-box">
        <div class="modal-header with-image">
          <!--<img src="../../assets/img/logo/orange.png" alt="couchgourmet Logo" class="logo">-->
          <span class="close" @click.prevent="close()">
              <icon name="close" scale="2"></icon>
            </span>
        </div>
        <h2 v-if="headline !== ''" >{{ headline }}</h2>
        <h4 v-if="subline !== ''" >{{ subline }}</h4>
        <div v-if="body !== ''" class="modal-body">
          <p>{{ body }}</p>
        </div>
        <div class="modal-action">
          <button v-if="secondary" class="btn icon black mr-3" @click.prevent="secondaryAction()"><span> {{ secondary }} </span>
          </button>
          <button class="btn icon green" @click.prevent="close()"><span> {{ button }} </span>
          </button>
        </div>
      </div>
  </modal>
</template>

<script>
  import {EventBus} from '@/assets/js/event-bus.js'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'infoModal',
    props: {
      name: {
        type: String,
        default: 'infoModal'
      },
      headline: {
        type: String,
        default: ''
      },
      subline: {
        type: String,
        default: ''
      },
      body: {
        type: String,
        default: ''
      },
      button: {
        type: String,
        default: 'Schließen'
      },
      secondary: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        show: false
      }
    },
    mounted () {
      EventBus.$on('toggleInfoModal', (name) => {
        if (!name || name === this.name) {
          this.toggleModal(name)
        }
      })
      EventBus.$on('escKey', () => {
        this.closingModal()
        this.close()
      })
    },
    beforeDestroy () {
      EventBus.$off('escKey')
    },
    mixins: [helpers, formatting],
    methods: {
      closingModal () {
        this.show = false
        this.iphoneModalsUnset()
      },
      toggleModal () {
        this.show = !this.show
        this.show ? this.$modal.show(this.name) : this.$modal.hide(this.name)
      },
      close () {
        this.iphoneModalsUnset()
        this.$emit('close')
      },
      secondaryAction () {
        this.$emit('secondary')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/info.vue